export default "__VITE_ASSET__70fc356b__"